<template>
  <div class="content">
    <div class="title">
      <div>
        <img src="../../static/images/23@2x.png" alt />
      </div>
      <div>巨细纺织织造工业互联网平台</div>
      <div>巨细科技</div>
    </div>

    <div class="content-view">
      <div class="list-one">
        <div class="fzqapp">
          <div>
            <div>
              <div>
                <div>
                  <img src="../../static/images/5@2x.png" alt />
                </div>
                <div>
                  <div>纺织圈APP</div>
                  <div style="font-size:20px">2019年度成交</div>
                </div>
              </div>
              <div>
                <div>
                  <div>{{datalist.chengJiaoDanLiang}}</div>
                  <div class="nametip">成交单量</div>
                </div>
                <div>
                  <div>{{datalist.chengJiaoMiShu}}万+</div>
                  <div class="nametip">成交米数</div>
                </div>
                <div>
                  <div>{{datalist.chengJiaoJinE}}</div>
                  <div class="nametip">成交金额</div>
                </div>
              </div>
            </div>
            <div id="myChart3" :style="{height: '310px'}"></div>
          </div>
        </div>
        <div class="ygc-content">
          <div>
            <div>
              <div>云工厂</div>
              <div>
                <div>
                  <div>{{datalist.yiJieDingDan}}</div>
                  <div class="nametip">已接订单</div>
                </div>
                <div>
                  <div>{{datalist.dingDanChanPin}}</div>
                  <div class="nametip">订单产品</div>
                </div>
                <div>
                  <div>
                    {{datalist.dingDanChanLiang}}
                    <span class="nametip">万米</span>
                  </div>
                  <div class="nametip">订单产量</div>
                </div>
              </div>
            </div>
            <div class="lengthitem">
              <div v-for="(item,i) in yunGongChangList.slice(0,5)" :key="i">
                <div>
                  <div class="nametip">{{item.yunGongChangName}}</div>
                  <div style="font-size:18px">{{item.wanChengShuLiang}}/{{item.dingDanShuLaing}}</div>
                </div>
                <div class="longlength">
                  <div :style="{width:(item.wanChengShuLiang/item.dingDanShuLaing*100)+'%'}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="list-two">
        <div class="listtwo-series">
          <div>
            <div>
              <div>
                <div>{{datalist.qiYeShuLiang}}</div>
                <div class="nametip">企业数量</div>
              </div>
              <div>
                <div>{{datalist.zongJiTaiShu}}万+</div>
                <div class="nametip">总机台数</div>
              </div>
              <div>
                <div>{{datalist.kaiJiLv}}%</div>
                <div class="nametip">开机率</div>
              </div>
            </div>
            <div>
              <div>
                <div>{{datalist.dangCheGong}}</div>
                <div class="nametip">挡车工</div>
              </div>
              <div>
                <div>{{datalist.jiXiuGong}}</div>
                <div class="nametip">机修工</div>
              </div>
              <div>
                <div>{{datalist.shangZhouGong}}</div>
                <div class="nametip">上轴工</div>
              </div>
              <div>
                <div>{{datalist.yanBuGong}}</div>
                <div class="nametip">验布工</div>
              </div>
            </div>
          </div>
        </div>
        <div class="fztype">
          <div>
            <div>
              <div>织机类型</div>
              <div id="myChart7" :style="{height: '310px',margin:'0px 0 0 0'}"></div>
            </div>
            <div>
              <div>
                <div>行业月平均效率</div>
                <div class="nametip">2019年度</div>
              </div>
              <div id="myChart1" :style="{height: '310px',margin:'0px 0 0 -20px'}"></div>
            </div>
          </div>
        </div>
        <div class="orderswatch">
          <div>
            <div class="left">
              <div>订单跟踪</div>
              <div>
                <div>
                  <div>{{datalist.benNianDuDanShu}}</div>
                  <div class="nametip">本年度单数</div>
                </div>
                <div>
                  <div>{{datalist.yiWanChenDanShu}}</div>
                  <div class="nametip">已完成单数</div>
                </div>
                <div>
                  <div>
                    {{datalist.yiWanChengChanLiang}}
                    <span class="nametip">万米</span>
                  </div>
                  <div class="nametip">已完成产量</div>
                </div>
              </div>
              <div id="myChart2" :style="{height: '240px',margin:'-20px 0 0px 0px'}"></div>
            </div>
            <div class="right">
              <div class="right-series">
                <div>仓库</div>
                <div>
                  <div>
                    <div class="nametip">在库卷数</div>
                    <div>{{datalist.zaiKuJuanShu || 0}}</div>
                  </div>
                  <div>
                    <div class="nametip">在库米数</div>
                    <div>
                      {{datalist.zaiKuMiShu || 0}}
                      <span class="nametip">万米</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-canvas">
                <div>
                  <div>
                    <div>
                      <img src="../../static/images/5449@2x.png" alt />
                      <span>本月入库</span>
                    </div>
                    <div>
                      <div>
                        <div>{{datalist.ruKuJuanShu}}</div>
                        <div class="nametip">卷数</div>
                      </div>
                      <div>
                        <div>{{datalist.ruKuMiShu}}</div>
                        <div class="nametip">米数(万米)</div>
                      </div>
                    </div>
                  </div>
                  <div id="myChart4" :style="{height: '185px',margin:'-5px 0 0 0'}"></div>
                </div>
                <div>
                  <div>
                    <div>
                      <img src="../../static/images/5448@2x.png" alt />
                      <span>本月出库</span>
                    </div>
                    <div>
                      <div>
                        <div>{{datalist.chuKuJuanShu}}</div>
                        <div class="nametip">卷数</div>
                      </div>
                      <div>
                        <div>{{datalist.chuKuMiShu}}</div>
                        <div class="nametip">米数(万米)</div>
                      </div>
                    </div>
                  </div>
                  <div id="myChart5" :style="{height: '185px',margin:'-28px 0 0 0'}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="list-three">
        <div class="listhree-series">
          <div>
            <div>
              <div>
                {{datalist.quNianChanLiang}}
                <span class="nametip">万米</span>
              </div>
              <div class="nametip">2018年度产量</div>
            </div>
            <div>
              <div>
                {{datalist.jinNianChanLiang}}
                <span class="nametip">万米</span>
              </div>
              <div class="nametip">2019年度产量</div>
            </div>
          </div>
        </div>
        <div class="productnumseries">
          <div>
            <div>
              <div>2019年度产量趋势</div>
              <div class="nametip">单位(万米)</div>
            </div>
            <div id="myChart6" :style="{height: '310px',margin:'0px 0 0 0'}"></div>
          </div>
        </div>
        <div class="productnum">
          <div>
            <div>
              <div>产品产量</div>
              <div>
                <span class="nametip">9月</span>
                <span class="nametip">单位(万米)</span>
              </div>
            </div>
            <div class="lengthitem">
              <div v-for="(item,i) in productList.slice(0,5)" :key="i" style="height:59px;">
                <div>
                  <div class="nametip">{{item.chanPinMing}}</div>
                  <div style="font-size:18px">{{item.chanLiang}}</div>
                </div>
                <div class="longlength">
                  <div :style="{width:(item.chanLiang/productList[0].chanLiang*100)+'%'}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="list-four">
        <div class="tablelist">
          <div>
            <div>原料涨跌幅</div>
            <div>
              <div>
                <div class="nametip">商品名称</div>
                <div class="nametip">价格</div>
                <div class="nametip">日涨跌幅</div>
              </div>
              <div v-for="(item,index) in rawList" :key="index">
                <div>{{item.yuanLianMing}}</div>
                <div>{{item.jiaGe}}</div>
                <div
                  style="width: 108px;height: 35px;margin-top: 13.5px;text-align: center;"
                  :style="item.riZhangDieFu<0?'background:#218D1D;':item.riZhangDieFu>0?'background:#EE3535;':''"
                >{{item.riZhangDieFu}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="canvans-cercle">
          <div>
            <div>染整、后整理工序</div>
            <div id="myChart8" :style="{height: '310px',margin:'0px 0 0 0'}"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "DataCenter_dark",
  data() {
    return {
      maxmin: {
        //柱状图 最大值最小值
        min: 0,
        max: 100
      },
      areaStyle: {
        change: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#4466F4" // 0% 处的颜色
              },
              {
                offset: 1,
                color: "transparent" // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          }
        },
        change2: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#FF106E" // 0% 处的颜色
              },
              {
                offset: 1,
                color: "transparent" // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          }
        },
        normal: {
          opacity: 0.1,
          color: "#4466F4"
        },
        none: {
          color: "transparent"
        }
      }, //折线图 面积样式 种类
      xseries: ["2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2"],
      yseries: [12, 52, 41, 52, 63, 12, 74, 45, 85, 74, 96, 12],
      datalist: "", //所有数据总和
      yunGongChangList: "", //云工厂
      productList: "", //产品产量
      rawList: "" //原料涨跌幅
    };
  },
  mounted() {
    this.getData();
  },
  created() {},
  destroyed() {},
  methods: {
    getData() {
      this.$axios({
        method: "post",
        url: "/api/showDataCenter/getShowData"
      })
        .then(res => {
          console.log(res.data.data);

          this.datalist = res.data.data.sumData;
          this.yunGongChangList = res.data.data.yunGongChangList;
          this.productList = res.data.data.productList;
          this.rawList = res.data.data.rawList;

          // 织机类型
          var seriesdata = [];
          for (var i = 0; i < res.data.data.loomTypeList.length; i++) {
            var item = {
              value: res.data.data.loomTypeList[i].biLi,
              name: res.data.data.loomTypeList[i].zhiJiLeiXing
            };
            seriesdata.push(item);
          }
          this.Getpiecanvas("myChart7", seriesdata);

          // 染整，后整理工序
          var seriesdata2 = [];
          for (var i = 0; i < res.data.data.gongXuList.length; i++) {
            var item = {
              value: res.data.data.gongXuList[i].biLi,
              name: res.data.data.gongXuList[i].gongXuMing
            };
            seriesdata2.push(item);
          }
          console.log(seriesdata2);
          this.Getpiecanvas("myChart8", seriesdata2);

          var chengJiaoJinE = [];
          var chuKuMiShu = [];
          var hangYeYueXiaoLv = [];
          var ruKuMiShu = [];
          var yiWanChengShuLiang = [];
          var yueChanLiang = [];
          var yueFen = [];
          // 2019图去掉0数据 未产生值的月份
          var newdata = [];

          for (var i = 0; i < res.data.data.monthDataList.length; i++) {
            chengJiaoJinE.push(
              Number(res.data.data.monthDataList[i].chengJiaoJinE)
            );
            chuKuMiShu.push(Number(res.data.data.monthDataList[i].chuKuMiShu));
            hangYeYueXiaoLv.push(
              Number(res.data.data.monthDataList[i].hangYeYueXiaoLv)
            );
            ruKuMiShu.push(Number(res.data.data.monthDataList[i].ruKuMiShu));
            yiWanChengShuLiang.push(
              Number(res.data.data.monthDataList[i].yiWanChengShuLiang)
            );
            yueChanLiang.push(
              Number(res.data.data.monthDataList[i].yueChanLiang)
            );
            yueFen.push(res.data.data.monthDataList[i].yueFen);
            newdata.push(res.data.data.monthDataList[i].yueFen);
          }

          // 2019图去掉0数据 未产生值的月份
          var lisitem = [];
          for (var i = 0; i < chengJiaoJinE.length; i++) {
            if (chengJiaoJinE[i] == 0) {
              lisitem.push(i);
            }
          }
          for (var i = 0; i < lisitem.length; i++) {
            chengJiaoJinE.splice(lisitem[i] - i, 1);
            hangYeYueXiaoLv.splice(lisitem[i] - i, 1);
            yueChanLiang.splice(lisitem[i] - i, 1);
            yiWanChengShuLiang.splice(lisitem[i] - i, 1);
            ruKuMiShu.splice(lisitem[i] - i, 1);
            chuKuMiShu.splice(lisitem[i] - i, 1);
            newdata.splice(lisitem[i] - i, 1);
          }

          // 纺织圈

          this.Getlinecanvas(
            "myChart3",
            "#4466F4",
            "smooth:true",
            this.areaStyle.normal,
            "0",
            newdata,
            chengJiaoJinE
          );
          // 行业月平均效率
          this.Getlinecanvas(
            "myChart1",
            "#FF106E",
            "",
            this.areaStyle.change2,
            "0",
            newdata,
            hangYeYueXiaoLv,
            this.maxmin
          );
          // 订单跟踪 1 柱状图
          this.Getbarcanvas(
            "myChart2",
            "#4466F4",
            newdata,
            yiWanChengShuLiang,
            "",
            0
          );
          // 仓库 本月入库
          this.Getlinecanvas(
            "myChart4",
            "#4466F4",
            "",
            this.areaStyle.none,
            "0",
            newdata,
            ruKuMiShu
          );
          // 仓库 本月出库
          this.Getlinecanvas(
            "myChart5",
            "#FF106E",
            "",
            this.areaStyle.none,
            "0",
            newdata,
            chuKuMiShu
          );
          // 2019年度产量趋势
          this.Getlinecanvas(
            "myChart6",
            "#4466F4",
            "smooth:true",
            this.areaStyle.change,
            "1",
            newdata,
            yueChanLiang
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 折线图
    Getlinecanvas(
      item,
      color,
      smooth,
      areaStyle,
      triggerwidth,
      arryX,
      arryY,
      maxmin
    ) {
      //1.图表id 2.图表颜色 3.是否平滑 4.是否有面积 5.提示框要不要竖线(线的粗细) 6.X轴标签 7.y轴数据 8.最大值最小值
      let myChart = this.$echarts.init(document.getElementById(item));
      // 绘制图表
      myChart.setOption({
        // 提示框
        tooltip: {
          trigger: "axis", // 触发类型，默认数据触发，见下图，可选为：'item' ¦ 'axis'
          backgroundColor: "rgba(0,0,0,0.8)", // 提示背景颜色，默认为透明度为0.7的黑色
          // 接受数组分别设定上右下左边距，同css
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
            lineStyle: {
              // 直线指示器样式设置
              color: "#4466F4",
              width: triggerwidth,
              type: "solid"
            }
          }
          // textStyle: {
          //   color: "#fff"
          // }
        },

        // 是否缩放
        // dataZoom: [
        //   {
        //     type: "inside"
        //   }
        // ],
        // 网格
        grid: { x: 60, y: 30, x2: 10, y2: 60 },
        xAxis: {
          show: true,
          // boundaryGap: false,//x轴是否贴边
          type: "category",
          name: "",
          // 坐标轴线
          axisLine: {
            show: true,
            lineStyle: {
              color: "#181C40",
              width: 1
            }
          },
          // 坐标轴标签
          axisTick: {
            show: false
          },
          // 坐标轴标签
          axisLabel: {
            margin: 16,
            color: "#8495C2",
            fontSize: 15
            // fontStyle: "normal",
            // align: "left",
          },
          data: arryX
        },
        yAxis: {
          maxmin,
          type: "value",
          // 坐标轴在 grid 区域中的分隔线。
          splitLine: {
            // show: true,
            // 背景线
            lineStyle: {
              color: "#181C40",
              width: 1
              // opacity: 1
            }
          },
          // 坐标轴线 y
          axisLine: {
            show: false
          },
          // 坐标轴标签 y
          axisTick: {
            show: false
          },
          // 坐标轴标签
          axisLabel: {
            show: true,
            margin: 20,
            // interval: 2,
            color: "#8495C2",
            align: "center",
            fontSize: 15
            // verticalAlign: "center"
          },
          splitNumber: 4
        },
        series: [
          {
            data: arryY,
            type: "line",
            smooth, //是否平滑
            areaStyle
            // symbol:'none', 拐弯点
          }
        ],
        lineStyle: {
          color: color
        },
        // 拐点设置
        itemStyle: {
          color: color
        }
      });
    },
    // 柱状图
    Getbarcanvas(item, sColor, xarry, yarry, maxmin, top) {
      // 绑定图表id  颜色  x轴 y轴 最大值最小值  最大值显示
      let myChart = this.$echarts.init(document.getElementById(item));
      // var yMax = 500;
      var dataShadow = [];

      var alltop = 0;
      for (var i = 0; i < yarry.length; i++) {
        if (yarry[i] > alltop) {
          alltop = yarry[i];
        }
      }
      // console.log(alltop)
      if (top != 100) {
        top = alltop;
      }

      myChart.setOption({
        // 提示框
        tooltip: {
          show: true, // 是否显示提示框，默认为true
          trigger: "item", // 数据项图形触发
          axisPointer: {
            // 指示样式
            type: "shadow",
            axis: "auto"
          },
          padding: 5,
          textStyle: {
            // 提示框内容的样式
            color: "#fff"
          }
        },

        // 网格
        grid: { x: 36, y: 40, x2: 30, y2: 45 },
        xAxis: {
          data: xarry,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#181C40",
              width: 1
            }
          },
          // 坐标轴标签
          axisTick: {
            show: false
          },
          // 坐标轴标签
          axisLabel: {
            margin: 20,
            color: "#8495C2",
            fontSize: 15,
            // rotate: 40, //倾斜角度
            align: "middle"
          }
        },
        yAxis: {
          maxmin,
          // interval:[0,25,50,75,100],
          // splitNumber: 4,
          axisLine: {
            show: false
          },

          splitLine: {
            // 背景线
            lineStyle: {
              color: "#181C40",
              width: 1
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#8495C2",
              fontSize: 15
            }
          }
        },
        // dataZoom: [
        //   {
        //     type: "inside"
        //   }
        // ],
        series: [
          {
            stack: "chart",
            z: 3,
            // For shadow
            // name: "效率",
            type: "bar",
            itemStyle: {
              color: sColor,
              barBorderRadius: 20
            },
            barWidth: 8,
            data: Object.keys(yarry).map(function(key) {
              return yarry[key];
            })
          },
          {
            type: "bar",
            stack: "chart",
            silent: true,
            itemStyle: {
              normal: {
                color: "#181C40",
                barBorderRadius: 20
              }
            },
            barGap: "-100%",
            barCategoryGap: "40%",
            data: Object.keys(yarry).map(function(key) {
              return top - yarry[key];
            }),

            barWidth: 8
          }
        ]
      });

      // Enable data zoom when user click bar.
    },
    //环形图
    Getpiecanvas(item, seriesdata) {
      let myChart = this.$echarts.init(document.getElementById(item));

      myChart.setOption({
        grid: { x: 0, y: 0, x2: 0, y2: 0 },
        // backgroundColor: "#001848",//背景颜色
        color: ["#FF106E", "#4365F3", "#F3E643", "#F39543", "#A600E2"],
        series: [
          {
            type: "pie",
            data: seriesdata,
            radius: ["40%", "50%"],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  textStyle: { color: "#fff", fontSize: "18" },
                  formatter: function(val) {
                    return "{a|" + val.name + "}{b| " + val.value + "%}";
                  },
                  rich: {
                    a: { color: "#8394C1", fontSize: 15 },
                    b: { color: "#fff", fontSize: 15 }
                  }
                },
                labelLine: {
                  show: true,
                  lineStyle: { color: "#8394C1" }
                }
              }
            }
          }
        ]
      });
      // var pie = echarts.init(document.getElementById("pie"));
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped type='text/css'>
.content {
  width: 100%;
  min-width: 3800px;
  background: #090918;
  font-size: 26px;
  .title {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    height: 77px;
    line-height: 77px;
    background: #0f122d;
    align-items: center;
    font-size: 26px;
    > div:nth-child(2) {
      font-size: 36px;
      font-weight: bold;
      letter-spacing: 10px;
    }
    img {
      width: 60px;
      margin-top: 26px;
    }
  }
  .content-view {
    padding: 25px;
    display: flex;
    .nametip {
      color: #8394c1;
      font-size: 20px;
    }
    > div:not(:last-child) {
      margin-right: 25px;
    }
    > div > div {
      background: #0f122d;
    }
    > div > div > div {
      padding: 25px;
    }
    .lengthitem > div {
      height: 66px;
      > div:first-child {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
      }
      > div:nth-child(2) {
        width: 100%;
        background: #181c40;
        height: 6px;
        border-radius: 6px;
        position: relative;
        > div {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          background: #ff106e;
          width: 60%;
          border-radius: 6px;
        }
      }
    }
    .list-one {
      width: 24%;
      > .fzqapp {
        height: 408px;
        margin-bottom: 25px;
        > div > div:first-child {
          line-height: 38px;
          display: flex;
          justify-content: space-between;
          > div:first-child {
            display: flex;
            align-items: center;
            img {
              width: 70px;
              margin-right: 15px;
            }
          }
          > div:nth-child(2) {
            display: flex;
            width: 45%;
            justify-content: space-between;
          }
        }
      }
      > .ygc-content {
        height: 488px;
        > div > div:first-child {
          display: flex;
          margin-bottom: 48px;
          justify-content: space-between;
          > div:nth-child(2) {
            display: flex;
            justify-content: space-between;
            width: 40%;
            > div {
              > div:first-child {
                margin-bottom: 13px;
              }
            }
          }
        }
      }
    }
    .list-two {
      width: 32.5%;
      > .listtwo-series {
        height: 121px;
        > div {
          display: flex;
          width: 100%;
          line-height: 35px;
        }
        > div > div:first-child {
          width: 45%;
          display: flex;
          border-right: 1px solid #1a1f51;
          > div:not(:last-child) {
            width: 31%;
          }
          > div {
            margin-left: 4%;
          }
        }
        > div > div:nth-child(2) {
          width: 55%;
          display: flex;
          margin-left: 5%;
          > div:not(:last-child) {
            width: 25%;
          }
        }
      }
      > .fztype {
        height: 365px;
        margin: 25px 0;
        > div {
          display: flex;
          > div:nth-child(1) {
            width: 40%;
          }
          > div:nth-child(2) {
            width: 60%;
            > div:nth-child(1) {
              display: flex;
              justify-content: space-between;
            }
          }
        }
      }
      > .orderswatch {
        height: 385px;
        > div {
          display: flex;
          .left {
            width: 40%;
            > div:nth-child(2) {
              display: flex;
              margin-top: 25px;
              line-height: 36px;
              > div {
                margin-right: 5%;
              }
            }
          }
          .right {
            width: 60%;
            .right-series {
              display: flex;
              > div:first-child {
                width: 33%;
              }
              > div:nth-child(2) {
                display: flex;
                width: 67%;
                > div {
                  display: flex;
                  align-items: center;
                  > div:not(:last-child) {
                    margin-right: 6px;
                  }
                }
                > div:first-child {
                  width: 46%;
                }
              }
            }
            .right-canvas > div:nth-child(1) > div:first-child {
              margin-top: 25px;
            }
            .right-canvas > div {
              display: flex;
              > div:first-child {
                width: 33%;
                > div:first-child {
                  margin-bottom: 15px;
                  > img {
                    width: 26px;
                    margin-right: 3px;
                  }
                  > span {
                    font-size: 16px;
                    font-weight: bold;
                  }
                }
                > div:nth-child(2) {
                  display: flex;
                  > div > div {
                    margin-bottom: 8px;
                  }
                  > div:first-child {
                    margin-right: 5%;
                  }
                }
              }
              > div:nth-child(2) {
                width: 67%;
              }
            }
          }
        }
      }
    }
    .list-three {
      width: 19.5%;
      > .listhree-series {
        height: 121px;
        line-height: 37px;
        > div {
          display: flex;
          justify-content: space-around;
        }
      }
      > .productnumseries {
        height: 365px;
        margin: 25px 0;
        > div > div:first-child {
          display: flex;
          justify-content: space-between;
        }
      }
      > .productnum {
        height: 385px;
        > div > div:first-child {
          margin-bottom: 26px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .list-four {
      width: 23%;
      height: 921px;
      background: #0f122d;
      .tablelist {
        height: 520px;
      }
      > .tablelist > div > div {
        > div:first-child {
          background: #181c40;
          margin-top: 25px;
          padding-left: 30px;
          height: 56px;
          line-height: 56px;
        }
        > div {
          height: 62px;
          border-bottom: 1px solid #1a1f51;
          display: flex;
          padding-left: 30px;
          > div:not(:last-child) {
            width: 41%;
            line-height: 62px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DataCenter_dark.vue